import { ISession } from '../models/pro-sites';
import * as CON from '../components/common/constants';
export const getContactUsLink = (session: ISession) => {
    if (session!.siteNumber === CON.AUDIBEL_US_SITE) {
        return CON.CONTACTUS_AUDIBEL;
    } else {
        return CON.CONTACTUS_STARKEY;
    }
};
